import Promisfy from 'utils/promisify';

export const isReady = new Promisfy();
